import { lazy } from 'react';

const DashboardLayout = lazy(() => import('features/dashboard/pages/Overview'));
const DashboardHome = lazy(() => import('features/dashboard/pages/Overview'));
const DashboardBookings = lazy(() => import('features/dashboard/pages/bookings/Bookings'));
const DashboardCustomers = lazy(() => import('features/dashboard/pages/customers/Customers'));
const DashboardSpaces = lazy(() => import('features/dashboard/pages/spaces/Spaces'));
const DashboardSpaceDetails = lazy(() => import('features/dashboard/pages/spaces/SpaceDetails'));
const DashboardSpaceCreateEdit = lazy(() => import('features/dashboard/pages/spaces/SpaceCreateEdit'));
const DashboardBookingDetails = lazy(() => import('features/dashboard/pages/bookings/BookingDetails'));
const DashboardCustomerDetails = lazy(() => import('features/dashboard/pages/customers/CustomerDetails'));
const DashboardPayments = lazy(() => import('features/dashboard/pages/payments/Payments'));
const DashboardPaymentDetails = lazy(() => import('features/dashboard/pages/payments/PaymentDetails'));
const DashboardUsers = lazy(() => import('features/dashboard/pages/users/Users'));

export const DASHBOARD_ROUTE = "/dashboard";
export const DASHBOARD_BOOKINGS_ROUTE = "/dashboard/bookings";
export const DASHBOARD_CUSTOMERS_ROUTE = "/dashboard/customers";
export const DASHBOARD_PROFILE_ROUTE = "/dashboard/profile";
export const DASHBOARD_SPACES_ROUTE = "/dashboard/spaces";
export const DASHBOARD_SPACES_DETAIL_ROUTE = "/dashboard/spaces/:spaceId";
export const DASHBOARD_SPACES_CREATE_EDIT_ROUTE = "/dashboard/spaces/create-edit/:spaceId";
export const DASHBOARD_BOOKING_DETAILS_ROUTE = "/dashboard/bookings/:bookingId";
export const DASHBOARD_CUSTOMER_DETAILS_ROUTE = "/dashboard/customers/:customerId";
export const DASHBOARD_PAYMENTS_ROUTE = "/dashboard/payments";
export const DASHBOARD_PAYMENT_DETAILS_ROUTE = "/dashboard/payments/:paymentId";
export const DASHBOARD_USERS_ROUTE = "/dashboard/users";


export const dashboardRoutes = [
    {
        path: DASHBOARD_ROUTE,
        element: <DashboardLayout />,
        children: [
            { index: true, element: <DashboardHome /> },
            { path: "analytics", element: <DashboardBookings /> },
        ],
    },
    {
        path: DASHBOARD_SPACES_ROUTE,
        element: <DashboardSpaces />
    },
    {
        path: DASHBOARD_SPACES_DETAIL_ROUTE,
        element: <DashboardSpaceDetails />
    },
    {
        path: DASHBOARD_SPACES_CREATE_EDIT_ROUTE,
        element: <DashboardSpaceCreateEdit />
    },
    {
        path: DASHBOARD_BOOKINGS_ROUTE,
        element: <DashboardBookings />
    },
    {
        path: DASHBOARD_BOOKING_DETAILS_ROUTE,
        element: <DashboardBookingDetails />
    },
    {
        path: DASHBOARD_CUSTOMERS_ROUTE,
        element: <DashboardCustomers />
    },
    {
        path: DASHBOARD_CUSTOMER_DETAILS_ROUTE,
        element: <DashboardCustomerDetails />
    },
    {
        path: DASHBOARD_PAYMENTS_ROUTE,
        element: <DashboardPayments />
    },
    {
        path: DASHBOARD_PAYMENT_DETAILS_ROUTE,
        element: <DashboardPaymentDetails />
    },
    {
        path: DASHBOARD_USERS_ROUTE,
        element: <DashboardUsers />
    }
];
